import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { URL_SERVICIOS_SOCKET } from '../config/config';
import { ENVIRONMENT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class OndemandSocketService {
  private socket: Socket;
  private doctorDisponible$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onDoctorNoDisponible$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onDoctorAceptaConsulta$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onDoctorFinalizaConsulta$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onActualizaFila$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onAsignaDoctor$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onAsignaDoctorModal$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject
  private onGetDetailOndemand$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject onGetDetailOndemand
  private onPause$ = new BehaviorSubject<any>(null); // cambia a BehaviorSubject onGetDetailOndemand

  constructor() {

    this.socket = io(URL_SERVICIOS_SOCKET, {
        transports: ['websocket'],
        withCredentials: true
      });

    this.socket.on('connect', () => {
      // console.log('✅ Socket conectado ondemand, url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
    });

    this.socket.on('connect_error', (err) => {
      console.error('❌ Error de conexión socket ondemand:', err, 'url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
    });

    this.socket.on('ondemand:doctor_disponible', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.doctorDisponible$.next(data);
    });
    this.socket.on('ondemand:doctor_no_disponible', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.doctorDisponible$.next(data);
    });
    this.socket.on('ondemand:doctor_acepta_consulta', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onDoctorAceptaConsulta$.next(data);
    });
    this.socket.on('ondemand:doctor_finaliza_consulta', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onDoctorFinalizaConsulta$.next(data);
    });
    this.socket.on('ondemand:actualizar_fila_paciente', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onActualizaFila$.next(data);
    });
    this.socket.on('ondemand:asignar_doctor', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onAsignaDoctor$.next(data);
    });
    this.socket.on('ondemand:details_ondemand', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onGetDetailOndemand$.next(data);
    });
    this.socket.on('ondemand:pausa_doctor', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onPause$.next(data);
    });
    this.socket.on('ondemand:asignar_doctor_modal', (data) => {
      // console.log('📥 Evento captado en constructor:', data);
      this.onAsignaDoctorModal$.next(data);
    });

    
  }


  onDoctorDisponible(): Observable<any> {
    return this.doctorDisponible$.asObservable();
  }
  onDoctorNoDisponible(): Observable<any> {
    return this.onDoctorNoDisponible$.asObservable();
  }
  onDoctorAceptaConsulta(): Observable<any> {
    return this.onDoctorAceptaConsulta$.asObservable();
  }
  onDoctorFinalizaConsulta(): Observable<any> {
    return this.onDoctorFinalizaConsulta$.asObservable();
  }
  onActualizaFila(): Observable<any> {
    return this.onActualizaFila$.asObservable();
  }
  onAsignaDoctor(): Observable<any> {
    return this.onAsignaDoctor$.asObservable();
  }
  onAsignaDoctorModal(): Observable<any> {
    return this.onAsignaDoctorModal$.asObservable();
  }
  onGetDetailOndemand(): Observable<any> {
    return this.onGetDetailOndemand$.asObservable();
  }
  onPause(): Observable<any> {
    return this.onPause$.asObservable();
  }
}